import React, { useEffect, useRef } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { NumberFilter } from '../filters/NumberFilter';

export const NumberField: FieldComponent<number, string[]> = ({
  onChange,
  isActive,
  value,
  defaultValue,
  intent,
  hasTooltip,
  disabled,
  mui,
  compact,
}) => {

  return (
    <>

    </>
  );

};

NumberField.includes = (query = [], value = NaN) =>
  query.length === 0 ||
  query.some((filter) => {
    const filterValue = parseFloat(filter);
    if (!isNaN(filterValue)) {
      return filterValue === value;
    }
    return false;
  });

NumberField.comparator = (one, other) => {
  if (other === undefined) return -1;
  if (one === undefined) return 1;
  return one - other;
};

NumberField.FilterRenderer = NumberFilter;
